module.exports = __webpack_public_path__ + "img/hop-Fung-logo.d2678dfb.svg";